export default function About() {
  return (
    <div className="container mx-auto max-h-[80vh] px-4 py-4 sm:py-8">
      <div className="mx-auto flex min-h-screen flex-col items-center bg-background-light p-4 dark:bg-background-dark">
        <h1 className="mb-4 text-4xl font-bold text-gray-900 dark:text-gray-100">About The App</h1>
        <p className="mb-4 text-center text-lg text-gray-900 dark:text-gray-100">
          Welcome to TrackToss!
        </p>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">What It Is </h2>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100">
              A modern, crowdsourced playlist web application that enables users to create and join
              playlists using QR codes. Built with a focus on real-time collaboration and seamless
              music sharing. <br></br>TrackToss was created to provide a fun and interactive way for
              people to share and enjoy music together. Whether you&#39;re at a party, gathering, or
              just hanging out with friends, TrackToss makes it easy to create and manage playlists
              collaboratively.
            </p>
          </div>
        </section>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">How It Works</h2>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100">
              You can create a playlist and generate a QR code for others to join. The app supports
              real-time updates, allowing your party-guests to see your playlist, add songs to it,
              and upvote or downvote the songs. <br /> The person creating the playlist is the
              hosts, and they are the only ones that can play the playlist and manage playlist
              settings. However, the playlist is public, and anyone with the QR code can join.
            </p>
          </div>
        </section>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">The Team</h2>
            <ul className="mb-4 mt-4 list-inside list-disc text-base text-gray-900 dark:text-gray-100">
              <li>
                <strong>TBD</strong> – Developer
              </li>
            </ul>
          </div>
        </section>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">Technologies Used</h2>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100">
              TrackToss is built using React, TypeScript, and Tailwind CSS for the frontend.
              <br></br> The backend is powered by Node.js and Vite, with Supabase for data storage.
            </p>
          </div>
        </section>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">Version</h2>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100">
              {__APP_VERSION__ || '1.0.0'}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
